import { render } from "./ProductDetailView.vue?vue&type=template&id=c493a8bc&ts=true"
import script from "./ProductDetailView.vue?vue&type=script&lang=ts"
export * from "./ProductDetailView.vue?vue&type=script&lang=ts"

import exportComponent from "/var/jenkins_home/workspace/TCD-GIFTSHOP-CHANNELING-FRONT/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__